import React, { Fragment } from 'react';
import { useLanguage } from '../i18n/LanguageProvider';
import { Dialog, DialogPanel, Transition, TransitionChild } from '@headlessui/react';

interface ErrorComponentProps {
  error: string;
  onRetry?: () => void;
  showRetryButton?: boolean;
}

const ErrorComponent: React.FC<ErrorComponentProps> = ({ 
  error, 
  onRetry, 
  showRetryButton = true 
}) => {
  const { t } = useLanguage();

  return (
    <Transition show as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={() => {}}>
        <TransitionChild
          as={Fragment}
          enter="ui-fade-enter"
          enterFrom="ui-fade-enter-from"
          enterTo="ui-fade-enter-to"
          leave="ui-fade-leave"
          leaveFrom="ui-fade-leave-from"
          leaveTo="ui-fade-leave-to"
        >
          <div className="fixed inset-0 bg-gray-900/30" />
        </TransitionChild>

        <TransitionChild
          as={Fragment}
          enter="ui-pop-enter"
          enterFrom="ui-pop-enter-from"
          enterTo="ui-pop-enter-to"
          leave="ui-pop-leave"
          leaveFrom="ui-pop-leave-from"
          leaveTo="ui-pop-leave-to"
        >
          <div className="fixed inset-0 flex items-center justify-center p-4">
            <DialogPanel className="pp-dialog-panel pp-dialog-panel-error">
              <div className="pp-dialog-row">
                <div className="pp-dialog-icon-error">⚠️</div>
                <div className="min-w-0">
                  <div className="pp-dialog-text-error">
                    {error}
                  </div>
                </div>
              </div>

              {showRetryButton && error !== t('missingAccess') && onRetry && (
                <div className="pp-dialog-actions">
                  <button
                    onClick={onRetry}
                    className="pp-btn-primary"
                  >
                    {t('retry')}
                  </button>
                </div>
              )}
            </DialogPanel>
          </div>
        </TransitionChild>
      </Dialog>
    </Transition>
  );
};

export default ErrorComponent;